/**
 * The policy manifest as the console uses it (AIOE-only; the mirrored shapes are policyManifest.ts
 * and policyManifestCheck.ts; docs/policy-manifest.md):
 *
 *   GET  /admin/v1/policy-manifests              every manifest the platform holds, newest build first
 *   GET  /admin/v1/policy-manifests/current      the manifest the editor renders from: the newest build among the organisation's machines, else the newest release's
 *   GET  /admin/v1/policy-manifests/:digest      one manifest, whole
 *   POST /admin/v1/policies/check                a policy against every manifest the organisation's machines run
 */
import { z } from "zod";
export const policyCheckRequestSchema = z.object({
    /** The policy document as the editor holds it; checked as written, not after defaults are filled in. */
    policy: z.record(z.string(), z.unknown()),
    /** The projects the policy is for; absent = the organisation's default policy, every machine. */
    projectIds: z.array(z.string().min(1).max(100)).max(200).optional(),
});
/**
 * A policy as written, with what this platform's schema filled in (defaults) and checked laid over
 * it: every section and field this build does not know is kept, at any depth, so a clause a newer
 * workbench understands (rendered from its policy manifest) survives a save untouched. Arrays are
 * the parsed value's; anything the schema rejected never reaches here.
 */
export function keepUnknownPolicy(raw, parsed) {
    const plain = (v) => typeof v === "object" && v !== null && !Array.isArray(v);
    if (!plain(raw) || !plain(parsed))
        return parsed;
    const out = { ...raw };
    for (const [k, v] of Object.entries(parsed))
        out[k] = keepUnknownPolicy(raw[k], v);
    return out;
}
//# sourceMappingURL=policyManifestAdmin.js.map